<template>
  <loading-container :loading="loading">
    <div class="mt-3">
      <!-- Column -->
      <div class="col-lg-3 col-md-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">{{ $t('dashboard') }}</h5>
            <div class="d-flex no-block align-items-center m-t-20 m-b-20">
              <h2 class="text-purple">
                <span class="counter">Info here</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <!-- Column -->
    </div>
    <!-- Section Shipment -->
  </loading-container>
</template>

<script>
  import _ from 'lodash';
  import { mapGetters, mapActions } from "vuex";
  import BarChart from "@/components/Chart/BarChart.js";
  import LoadingContainer from "@/components/Misc/LoadingContainer";
  import helper from "@/libs/helper"

  export default {
    name: "FreeDashboard",
    beforeMount() {
    },
    components: {
      BarChart,
      LoadingContainer,
    },
    computed: {
      ...mapGetters({
        loading: "dashboard/loading",
      }),
    },
    methods: {
      ...mapActions({
        getAdminOverview: "dashboard/getAdminOverview",
      }),
    }
  };
</script>
<style scoped>
</style>
